import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import AppButton from '../../styles/common/AppButton';
import btnClose from '../../images/common/close.svg';
import * as actionTypes from '../../actions/actionTypes';
import exportTags from '../../actions/api/tag/exportTags';
import reimportTags from '../../actions/api/tag/reimportTags';
import {
  Main,
  Contents,
  Header,
  CloseButton,
  CloseButtonImage,
  ImportInput,
  MessageItem,
} from '../../styles/common/Dialog';
import {
  Dialog,
  MessageWrapper,
  ButtonWrapper,
  ImportButton,
} from './styles/MasterImportDialogStyles';

/**
 * タグのインポートおよびエクスポート（全階層）を行うためのダイアログを表示するコンポーネント。
 * 特定のタグセットに関連するタグのインポートおよびエクスポートを行う。
 */
const MasterImportDialog = () => {
  const dispatch = useDispatch();
  const { apiToken, selectedTagSetId } = useSelector(state => ({
    apiToken: state.main.apiToken,
    selectedTagSetId: state.master.selectedTagSetId,
  }));

  const handleCloseDialog = () => {
    dispatch({ type: actionTypes.CLOSE_MASTER_IMPORT_DIALOG });
  };

  const handleClickAddButton = () => {
    dispatch(exportTags(apiToken, selectedTagSetId));
    dispatch({ type: actionTypes.CLOSE_MASTER_IMPORT_DIALOG });
  };

  const handleTagReimport = e => {
    dispatch({ type: actionTypes.CLOSE_MASTER_IMPORT_DIALOG });
    dispatch({ type: 'REQUEST_API_REIMPORT_TAGS' });
    dispatch(reimportTags(apiToken, e.target.files[0], selectedTagSetId));
  };

  return (
    <Main
      id="closeConfirmMasterImportDialog"
      role="presentation"
      onClick={handleCloseDialog}
    >
      <Dialog role="presentation" onClick={e => e.stopPropagation()}>
        <Contents>
          <Header>
            <FormattedMessage id="master.MasterImportDialog.title" />
            <CloseButton
              id="closeButton"
              role="presentation"
              className="button"
              onClick={handleCloseDialog}
            >
              <CloseButtonImage src={btnClose} alt="close" />
            </CloseButton>
          </Header>
          <div>
            <MessageWrapper>
              <MessageItem>
                <FormattedMessage id="master.MasterImportDialog.export.message1" />
              </MessageItem>
            </MessageWrapper>
            <ButtonWrapper>
              <AppButton
                large
                className="button"
                bgColor="white"
                color="black"
                onClick={handleClickAddButton}
              >
                <FormattedMessage id="master.MasterImportDialog.export.button" />
              </AppButton>
            </ButtonWrapper>
            <MessageItem>
              <FormattedMessage id="master.MasterImportDialog.import.message1" />
            </MessageItem>
            <ButtonWrapper>
              <ImportButton type="file" accept=".csv">
                <ImportInput
                  type="file"
                  accept=".csv"
                  onChange={handleTagReimport}
                />
                <FormattedMessage id="master.OneLayerMasterImportDialog.button.import" />
              </ImportButton>
            </ButtonWrapper>
          </div>
        </Contents>
      </Dialog>
    </Main>
  );
};

export default injectIntl(MasterImportDialog);
